import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// Routes
import routesPages from './config/routes/routesPages';
// Style
import './App.css';
import { setNavigate } from './config/services/navigationService';
import React from 'react';

function App() {

  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);


  return (
      <Routes>
        {routesPages.map((route, index) => (
          <Route key={index} path={route.path} element={<route.layout />}>
            <Route path={route.path} element={<route.component/>} />
          </Route>
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}

export default App;
